import Widget from "../../../components/Widget/Widget";
import { useSelector } from "react-redux";
import { Button, Nav, NavItem, NavLink } from "reactstrap";
import { useEffect, useState } from "react";
import DocumentacionP from "./DocumentacionP";
import RegistrarP from "./RegistrarP";
import ActividadesP from "./ActividadesP";
import CostosP from "./CostosP";
import ValidarP from "./ValidarP";
import { GetPermissions } from "../../../libs/permissions/getPermissions";
/* import ButtonPdfGastosComponent from "../componentes/others/ButtonPdfGastosComponent"; */

const s = { fontSize: "18px", marginRight: "5px" };
const defaultProyect = {
  id: 0,
  dateS: "",
  dateE: "",
  name: "",
  objetive: "",
  keyStat: "",
  canEdit: true,
  notes: "",
};

const RegistroProyectos = () => {
  const [permissions, setPermissions] = useState({});
  GetPermissions(setPermissions);
  
  const { profileType } = useSelector((state) => state.userInfo);
  const idArea = profileType.selectProfile.idArea;

  const [activeTab, setActiveTab] = useState(1);
  const [proyect, setProyect] = useState({ ...defaultProyect });

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    if (proyect.id !== 0) toggleTab(2);
    else toggleTab(1);
  }, [proyect]);

  return (
    <Widget className="widget-p-md">
      <Nav fill tabs style={{ overflowY: "hidden", overflowX: "auto" }}>
        <NavItem active={activeTab === 1}>
          <NavLink
            href="#"
            active={activeTab === 1}
            onClick={() => toggleTab(1)}
            disabled={proyect.id > 0}
          >
            <i className={"fa fa-cogs"} style={s} />
            Proyecto
          </NavLink>
        </NavItem>
        <NavItem active={activeTab === 2}>
          <NavLink
            href="#"
            active={activeTab === 2}
            onClick={() => toggleTab(2)}
            disabled={!proyect.id > 0}
          >
            <i className={"fa fa-file-text-o"} style={s} />
            Documentación
          </NavLink>
        </NavItem>
        <NavItem active={activeTab === 3}>
          <NavLink
            href="#"
            active={activeTab === 3}
            onClick={() => toggleTab(3)}
            disabled={!proyect.id > 0}
          >
            <i className={"fa fa-tasks"} style={s} />
            Actividades
          </NavLink>
        </NavItem>
        <NavItem active={activeTab === 4}>
          <NavLink
            href="#"
            active={activeTab === 4}
            onClick={() => toggleTab(4)}
            disabled={!proyect.id > 0}
          >
            <i className={"fa fa-money"} style={s} />
            Costo del proyecto
          </NavLink>
        </NavItem>
        <NavItem active={activeTab === 5}>
          <NavLink
            href="#"
            active={activeTab === 5}
            onClick={() => toggleTab(5)}
            disabled={!proyect.id > 0}
          >
            <i className={"fa fa-check-square-o"} style={s} />
            Validación
          </NavLink>
        </NavItem>
      </Nav>
      <div className="mt-2">
        {proyect.id !== 0 && (
          <div className="d-flex justify-content-end mb-2">
            <Button
              className="btn text-light px-2 py-1"
              style={{ backgroundColor: "#cc0a44", border: "none" }}
              onClick={() => setProyect({ ...defaultProyect })}
            >
              Cerrar
              <i className="fa fa-sign-out ml-2" style={{ fontSize: "16px" }} />
            </Button>
          </div>
        )}
        {activeTab === 1 ? (
          <RegistrarP idArea={idArea} setProyect={setProyect} permissions={permissions} />
        ) : activeTab === 2 ? (
          <>
          <DocumentacionP proyectId={proyect.id} canEdit={proyect.canEdit} permissions={permissions} />
          </>
        ) : activeTab === 3 ? (
          <ActividadesP
            idArea={idArea}
            proyectId={proyect.id}
            canEdit={proyect.canEdit}
            datesLimit={[proyect.dateS, proyect.dateE]}
            permissions={permissions}
          />
        ) : activeTab === 4 ? (
          <CostosP proyect={proyect} permissions={permissions} />
        ) : (
          <ValidarP proyect={proyect} setProyect={setProyect} />
        )}
      </div>
    </Widget>
  );
};

export default RegistroProyectos;
